module.exports = __webpack_public_path__ + "img/ms.2b60f1b7.svg";